import type { FilterDropdownProps } from '../../types';
import type { AppInputNumberRef } from 'shared/UI/UIKit/InputNumber';
import type { NumberFilterFormValue } from './types';
import { useFilterDropdown } from '../../hooks/use-filter-dropdown';
import { FilterForm } from '../FilterForm';
import { NumberFilterFields } from './filter-fields';
import {
  getInitialFormValues,
  getFilterToSubmit,
  getFilterToReset,
} from './NumberFilterDropdown.utils';

export const NumberFilterDropdown = (props: FilterDropdownProps) => {
  const { form, focusRef, onSubmit, onReset } = useFilterDropdown<
    NumberFilterFormValue,
    AppInputNumberRef
  >({
    ...props,
    getInitialFormValues,
    getFilterToSubmit,
    getFilterToReset,
  });

  return (
    <FilterForm form={form} filterType={props.filter.type} onSubmit={onSubmit} onReset={onReset}>
      <NumberFilterFields form={form} focusRef={focusRef} options={props.filter.options} />
    </FilterForm>
  );
};
